$(document).ready(function () {
  // function updateCartUI() {
  //   console.log(Shopify, "shopify");
  //   $.getJSON("/cart.js", function (cart) {
  //     // const displayCurrency = cart.currency;
  //     // const storeCurrency = currencySymbols[displayCurrency] || displayCurrency;
  //     const storeCurrency = cart.currency;
  //     // Update cart count
  //     $(".cart-count").text(cart.item_count);

  //     // Show/hide empty cart message and cart wrapper
  //     if (cart.item_count === 0) {
  //       $(".cart-empty").removeClass("d-none");
  //       $(".cart-wrapper, .offcanvas-footer, .mobileCartCheck").addClass(
  //         "d-none"
  //       );
  //     } else {
  //       $(".cart-empty").addClass("d-none");
  //       $(".cart-wrapper, .offcanvas-footer, .mobileCartCheck").removeClass(
  //         "d-none"
  //       );
  //     }

  //     // Clear and update cart contents
  //     const $cartWrapper = $(".cart-wrapper");
  //     $cartWrapper.html(""); // Use .html('') instead of .empty() for reliability
  //     cart.items.forEach((item) => {
  //       // const itemPrice = (item.price / 100).toFixed(2).replace(/\.00$/, "");
  //       const itemPrice = (item.price / 100).toLocaleString();

  //       const itemHtml = `
  //                   <div class="cart-data" data-product-id="${
  //                     item.id
  //                   }" data-main-product-id="${item.properties?.mainProductId}">
  //                       <div class="cart-image">
  //                           <a href="${item.url}">
  //                               <img src="${item.image}" alt="${item.title}">
  //                           </a>
  //                       </div>
  //                       <div class="cart-details">
  //                         <h2 class="cart-product-title">${item.title}</h2>
  //                         ${
  //                           item.properties?.hasBlouse
  //                             ? '<h4 class="cart-measurement"><a href="#" class="show-measurement" data-bs-toggle="modal" data-bs-target="#stritching_details">Measurement Details</a></h4>'
  //                             : ""
  //                         }

  //                         ${item.properties?.note ? item.properties.note : ""}
  //                         <p class="cart-product-price">${storeCurrency} ${itemPrice}</p>
  //                         <div class="cart-button-wrapper">
  //                             <div class="add-sub-button">
  //                                 <span><button class="decrease-quantity">-</button></span>
  //                                 <span><input type="text" value="${
  //                                   item.quantity
  //                                 }" readonly></span>
  //                                 <span><button class="increase-quantity">+</button></span>
  //                             </div>
  //                             <button class="cart-remove-btn" data-variant-id="${
  //                               item.id
  //                             }">REMOVE</button>
  //                         </div>
  //                       </div>
  //                   </div>
  //               `;
  //       $cartWrapper.append(itemHtml);
  //     });

  //     // Update cart subtotal
  //     const cartTotal = (cart.total_price / 100)
  //       .toFixed(2)
  //       .replace(/\.00$/, "");
  //     $(".offcanvas-footer .cart-sub-wrapper p:last-child").html(
  //       `${storeCurrency} ${cartTotal}`
  //     );
  //   });
  // }

  function updateCartUI() {
    console.log(Shopify, "shopify");

    $.getJSON("/cart.js", function (cart) {
      const storeCurrency = cart.currency;
      const $cartWrapper = $(".cart-wrapper");
      $cartWrapper.html(""); // Clear previous cart items

      // Update cart count
      $(".cart-count").text(cart.item_count);

      // Show/hide empty cart message and cart wrapper
      if (cart.item_count === 0) {
        $(".cart-empty").removeClass("d-none");
        $(
          ".cart-wrapper, .offcanvas-footer, .mobileCartCheck, .checkout-card"
        ).addClass("d-none");
      } else {
        $(".cart-empty").addClass("d-none");
        $(
          ".cart-wrapper, .offcanvas-footer, .mobileCartCheck, .checkout-card"
        ).removeClass("d-none");
      }

      const freeProductId = 45442087059618; // silver free product ID
      const allowedProductTypes = [
        "Anklets",
        "Bangles",
        "Bracelets",
        "Chain",
        "Choker",
        "Earrings",
        "Kada",
        "Men's Bracelet",
        "Necklaces",
        "Pendant",
        "Ring",
        "Silver Coins",
        "Statue",
        "Toe Rings",
      ];

      let eligibleItems = cart.items.filter((item) => {
        console.log(item.product_type, "item.product_type");
        return allowedProductTypes.includes(item.product_type);
      });
      let eligibleTotalCents = eligibleItems.reduce(
        (sum, item) => sum + item.line_price,
        0
      );
      let eligibleTotal = eligibleTotalCents / 100;
      console.log(eligibleTotal, "eligibleTotal");
      let requiredFreeQuantity = 0;
      if (eligibleTotal >= 45000) {
        requiredFreeQuantity = 3;
      } else if (eligibleTotal >= 30000) {
        requiredFreeQuantity = 2;
      } else if (eligibleTotal >= 15000) {
        requiredFreeQuantity = 1;
      }

      // const freeProductId = 42678658596933; // your free silver product
      const currentFreeItems = cart.items.filter(
        (item) => item.id === freeProductId
      );
      const currentFreeQuantity =
        currentFreeItems.length > 0 ? currentFreeItems[0].quantity : 0;

      if (
        requiredFreeQuantity > 0 &&
        currentFreeQuantity < requiredFreeQuantity
      ) {
        // Need to add or increase free product quantity
        const quantityToAdd = requiredFreeQuantity - currentFreeQuantity;

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: JSON.stringify({
            items: [
              {
                id: freeProductId,
                quantity: quantityToAdd,
              },
            ],
          }),
          contentType: "application/json",
          dataType: "json",
          success: function () {
            console.log("Free product added.");
            updateCartUI(); // refresh again after adding
          },
          error: function (err) {
            console.error("Error adding free gift:", err);
          },
        });
      } else if (requiredFreeQuantity === 0 && currentFreeQuantity > 0) {
        // Need to remove free product
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: JSON.stringify({
            id: currentFreeItems[0].key, // careful: use item.key not item.id for change.js
            quantity: 0,
          }),
          contentType: "application/json",
          dataType: "json",
          success: function () {
            console.log("Free product removed.");
            updateCartUI(); // refresh again after removing
          },
          error: function (err) {
            console.error("Error removing free gift:", err);
          },
        });
      }

      cart.items.forEach((item) => {
        const isFreeProduct = item.id === freeProductId;

        if (isFreeProduct) {
          if (requiredFreeQuantity === 0) {
            console.log(
              "Customer no longer eligible for free gift. Skipping display."
            );
            return;
          }
        }

        const itemPrice = (item.price / 100).toLocaleString();

        const itemHtml = `
          <div class="cart-data" data-product-id="${
            item.id
          }" data-main-product-id="${item.properties?.mainProductId}">
            <div class="cart-image">

            ${
              item.id == "45210532839586"
                ? `<a href="${item.url}"><img src="https://cdn.shopify.com/s/files/1/0611/3375/0341/files/Pico_Falls_2x_20209034-991b-46f8-bd24-5f119aebcd2e.png" alt="${item.title}"/></a>`
                : `<a href="${item.url}"><img src="${item.image}" alt="${item.title}"/></a>`
            }
            

              

            </div>
            <div class="cart-details">
              <h2 class="cart-product-title">${item.title}</h2>
              ${
                item.properties?.hasBlouse
                  ? '<h4 class="cart-measurement"><a href="#" class="show-measurement" data-bs-toggle="modal" data-bs-target="#stritching_details">Measurement Details</a></h4>'
                  : ""
              }
              ${
                item.properties?.note
                  ? `<p class="cart-additional-note">${item.properties.note}</p>`
                  : ""
              }
              <p class="cart-product-price">${storeCurrency} ${itemPrice}</p>
              <div class="cart-button-wrapper">
                <div class="add-sub-button">
                  <span><button class="decrease-quantity">-</button></span>
                  <span><input type="text" value="${
                    item.quantity
                  }" readonly></span>
                  <span><button class="increase-quantity">+</button></span>
                </div>
                <button class="cart-remove-btn" data-variant-id="${
                  item.id
                }">REMOVE</button>
              </div>
            </div>
          </div>
        `;

        $cartWrapper.append(itemHtml);
      });

      // Update cart subtotal
      const cartTotal = (cart.total_price / 100)
        .toFixed(2)
        .replace(/\.00$/, "");
      $(".offcanvas-footer .cart-sub-wrapper p:last-child").html(
        `${storeCurrency} ${cartTotal}`
      );
    });
  }

  $(".addtocart").click(function (e) {
    e.preventDefault();
    const addToCartText = this.querySelector(".add-to-cart-text");
    const originalText = addToCartText ? addToCartText.textContent : "";

    if (addToCartText) {
      addToCartText.textContent = "Please Wait";
    }

    // const fallVariantId = "42616003395653"; // dev
    const fallVariantId = "45210532839586"; // prod
    var $button = $(this); // Reference to the clicked button
    var productId = $button.data("product-id");
    let itemsToAdd = [
      {
        id: productId,
        quantity: 1,
        properties: {},
      },
    ];

    let measurementCheckbox = document.querySelector(
      "#blouseStitchingCheckbox"
    );
    if (measurementCheckbox && measurementCheckbox.checked) {
      // Get the product id from the measurement form (if it exists)
      let blouseStitchingProductId = document.getElementById(
        "blouseStitchingProductId"
      ).value;
      let measurementDetails =
        JSON.parse(localStorage.getItem("measurementDetails")) || {};
      if (measurementDetails[blouseStitchingProductId]) {
        let details = measurementDetails[blouseStitchingProductId];
        // Merge measurement details into the properties of the main item.
        // You can adjust the keys as needed.
        itemsToAdd[0].properties = Object.assign({}, itemsToAdd[0].properties, {
          "Blouse Name": details.blouseName,
          "Front Neck Design": details.frontNeckDesign,
          "Back Neck Design": details.backNeckDesign,
          "Sleeve Design": details.sleeveDesign,
          "Opening Design": details.openingDesign,
          "Arm Hole Length": details.armholeLength,
          "Sleeve Length": details.sleeveLength,
          "Sleeve Circumference": details.sleeveCircumference,
          "Blouse Length": details.blouseLength,
          "Chest Length": details.chestLength,
          "Waist Length": details.waistLength,
          "Shoulder Length": details.shoulderLength,
          "Shoulder To Apex": details.shoulderToApex,
          "Front Neck Depth Length": details.frontNeckDepthLength,
          "Back Neck Depth Length": details.backNeckDepth,
          "Product Name": details.productName,
          hasBlouse: details.hasBlouse,
          mainProductId: details.mainProductId,
        });
        let cartNote = `Stitching for ${details.productName}`;
        itemsToAdd.push({
          // id: "42572875464773", // dev
          id: "45211042676898", // prod
          quantity: 1,
          properties: {
            note: cartNote,
            "Blouse Name": details.blouseName,
            "Front Neck Design": details.frontNeckDesign,
            "Back Neck Design": details.backNeckDesign,
            "Sleeve Design": details.sleeveDesign,
            "Opening Design": details.openingDesign,
            "Arm Hole Length": details.armholeLength,
            "Sleeve Length": details.sleeveLength,
            "Sleeve Circumference": details.sleeveCircumference,
            "Blouse Length": details.blouseLength,
            "Chest Length": details.chestLength,
            "Waist Length": details.waistLength,
            "Shoulder Length": details.shoulderLength,
            "Shoulder To Apex": details.shoulderToApex,
            "Front Neck Depth Length": details.frontNeckDepthLength,
            "Back Neck Depth Length": details.backNeckDepth,
            "Product Name": details.productName,
            hasBlouse: details.hasBlouse,
            mainProductId: details.mainProductId,
          },
        });
      } else {
        console.log(
          "No measurement details found for product: " +
            blouseStitchingProductId
        );
      }
    } else {
      console.log("Measurement checkbox is not checked.");
    }

    console.log("itemstoadd", itemsToAdd);

    let cartNote = "";
    let fallAddOn = document.querySelector('[add-on="fall"]');

    if (fallAddOn && fallAddOn.checked) {
      let forProduct = fallAddOn.getAttribute("for-product");
      if (forProduct) {
        cartNote = `Add-on for: ${forProduct}`;
      }
      itemsToAdd.push({
        id: fallVariantId,
        quantity: 1,
        properties: {
          note: cartNote, // Passing the product name as a note for fall addon.
        },
      });
    } else {
      console.log("The Fall Add-On is NOT checked.");
    }
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ items: itemsToAdd }),
      contentType: "application/json",
      dataType: "json",
      success: function (data) {
        if (addToCartText) {
          addToCartText.textContent = originalText;
        }
        // Ensure the UI updates only after the cart is updated
        $.getJSON("/cart.js", function (cart) {
          updateCartUI(cart);
          $(".cartbelow").text(`(${cart.item_count} Items)`);

          // Open the sidebar AFTER cart updates
          const offcanvas = new bootstrap.Offcanvas(
            document.getElementById("cartshopping")
          );
          offcanvas.show();
        });
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = XMLHttpRequest.responseJSON;

        if (
          response &&
          response.message &&
          response.message.includes("out of stock")
        ) {
          alert("Sorry, this product is out of stock.");
          $button.text("Out of Stock").attr("disabled", true);
        } else {
          console.log("Error:", textStatus);
          showSimpleToast(response.description, "danger");
          $button.text("Add to Cart").attr("disabled", false);
        }
      },
    });
  });

  // Delegate to the parent so that dynamically added items also get this handler
  $(".cart-wrapper").on("click", ".cart-remove-btn", function (e) {
    e.preventDefault();

    // Grab the variant ID from the data attribute
    const variantId = $(this).data("variant-id");

    // The container for this specific cart item
    const $cartItem = $(this).closest(".cart-data");

    // Make the AJAX call to remove this item (set quantity to 0)
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: variantId,
        quantity: 0,
      },
      dataType: "json",
      success: function (cart) {
        $cartItem.slideUp(300, function () {
          $(this).remove();
        });

        $(".cart-count").text(cart.item_count);
        $(".cartbelow").text(`(${cart.item_count} Items)`);
        updateCartUI();
        // Update the cart subtotal
        const cartTotal = (cart.total_price / 100)
          .toFixed(2)
          .replace(/\.00$/, "");
        $(".offcanvas-footer .cart-sub-wrapper p:last-child").html(
          `${cart.currency} ${cartTotal}`
        );
      },
      error: function (xhr, textStatus) {
        console.log("Error removing item from cart:", textStatus);
        // Optionally, display an error message to the user
      },
    });
  });

  // Increase/Decrease quantity
  $(".cart-wrapper").on(
    "click",
    ".increase-quantity, .decrease-quantity",
    function (e) {
      e.preventDefault();

      // Get the container for the specific cart item
      const $cartItem = $(this).closest(".cart-data");

      // Reuse the variant ID from the remove button (or store it elsewhere if you prefer)
      const variantId = $cartItem.find(".cart-remove-btn").data("variant-id");

      // Grab the quantity input
      const $quantityInput = $cartItem.find('input[type="text"]');
      let currentQty = parseInt($quantityInput.val(), 10);

      // Increment or decrement the quantity based on the clicked button
      if ($(this).hasClass("increase-quantity")) {
        currentQty++;
      } else {
        currentQty--;
        // Optionally remove item if qty < 1, or just set minimum 1:
        if (currentQty < 1) currentQty = 1;
      }

      // Now send the updated quantity to Shopify
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: {
          id: variantId,
          quantity: currentQty,
        },
        dataType: "json",
        success: function (cart) {
          // If the item still exists in the cart, update the UI
          const updatedItem = cart.items.find((item) => item.id == variantId);

          if (updatedItem) {
            // Update the input field with the new quantity
            $quantityInput.val(updatedItem.quantity);
          } else {
            // If the item doesn't exist, it means its quantity went to 0 and it was removed
            $cartItem.slideUp(300, function () {
              $(this).remove();
            });
          }

          // Update cart count
          $(".cart-count").text(cart.item_count);
          $(".cartbelow").text(`(${cart.item_count} Items)`);

          // Update the cart subtotal
          const cartTotal = (cart.total_price / 100)
            .toFixed(2)
            .replace(/\.00$/, "")
            .toLocaleString();
          $(".offcanvas-footer .cart-sub-wrapper p:last-child").html(
            `${cart.currency} ${cartTotal}`
          );
          function formatPriceRupees(price) {
            return (price / 100).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          }
          $(".checkout-subtotal-mob").text(
            cart.currency + " " + formatPriceRupees(cart.items_subtotal_price)
            // formatPriceRupees(cart.items_subtotal_price)
          );
          $(".cart-total-mob").text(formatPriceRupees(cart.total_price));
        },
        error: function (xhr, textStatus) {
          // Check if it’s our 422 “unavailable” error
          if (
            xhr.status === 422 &&
            xhr.responseJSON &&
            xhr.responseJSON.message
          ) {
            // 1. Show a user-friendly alert or custom UI error message
            //   alert(xhr.responseJSON.message);

            // 2. (Optional) Re-sync the cart UI so the user sees correct quantities
            updateCartUI();
          } else {
            console.error("Error changing quantity:", textStatus);
            // Show some generic error message to the user if you want
          }
        },
      });
    }
  );

  window.addEventListener("pageshow", function () {
    // The page was accessed via the back/forward cache
    updateCartUI();
  });

  // Delegate click event for "Measurement Details" link.
  $(".cart-wrapper").on("click", ".show-measurement", function (e) {
    e.preventDefault();
    console.log("showing the measurement detauls");
    let $cartItem = $(this).closest(".cart-data");
    let productId = $cartItem.data("productId"); // Unique product/variant ID
    // 42572875464773  dev
    // 45211042676898  prod
    if (productId == 45211042676898) {
      productId = $cartItem.data("mainProductId");
    }
    let measurements =
      JSON.parse(localStorage.getItem("measurementDetails")) || {};

    if (measurements[productId]) {
      let data = measurements[productId];
      // Build the modal content dynamically.
      let modalContent = `
            <div class="single-detail-wrapper">
              <h2 class="final-details-title">Blouse Design Type</h2>
              <div class="content-two-grid">
                <div class="label-wrapper">
                  <div class="label">Front Neck Design</div>
                  <div class="dot">:</div>
                </div>
                <div class="details-value">${
                  data.frontNeckDesign || "N/A"
                }</div>
              </div>
              <div class="content-two-grid">
                <div class="label-wrapper">
                  <div class="label">Back Neck Design</div>
                  <div class="dot">:</div>
                </div>
                <div class="details-value">${data.backNeckDesign || "N/A"}</div>
              </div>
              <div class="content-two-grid">
                <div class="label-wrapper">
                  <div class="label">Sleeve Design</div>
                  <div class="dot">:</div>
                </div>
                <div class="details-value">${data.sleeveDesign || "N/A"}</div>
              </div>
              <div class="content-two-grid">
                <div class="label-wrapper">
                  <div class="label">Opening Design</div>
                  <div class="dot">:</div>
                </div>
                <div class="details-value">${data.openingDesign || "N/A"}</div>
              </div>
            </div>
            <div class="single-detail-wrapper">
              <h2 class="final-details-title">Sleeve Measurements</h2>
              <div class="content-two-grid">
                <div class="label-wrapper">
                  <div class="label">Armhole</div>
                  <div class="dot">:</div>
                </div>
                <div class="details-value">${data.armholeLength || "N/A"}</div>
              </div>
              <div class="content-two-grid">
                <div class="label-wrapper">
                  <div class="label">Sleeve Length</div>
                  <div class="dot">:</div>
                </div>
                <div class="details-value">${data.sleeveLength || "N/A"}</div>
              </div>
              <div class="content-two-grid">
                <div class="label-wrapper">
                  <div class="label">Sleeve Circumference</div>
                  <div class="dot">:</div>
                </div>
                <div class="details-value">${
                  data.sleeveCircumference || "N/A"
                }</div>
              </div>
            </div>
            <div class="single-detail-wrapper">
              <h2 class="final-details-title">Blouse Measurements</h2>
              <div class="content-two-grid">
                <div class="">
                  <div class="content-two-grid">
                    <div class="label-wrapper">
                      <div class="label">Blouse Length</div>
                      <div class="dot">:</div>
                    </div>
                    <div class="details-value">${
                      data.blouseLength || "N/A"
                    }</div>
                  </div>
                  <div class="content-two-grid">
                    <div class="label-wrapper">
                      <div class="label">Chest/Bust</div>
                      <div class="dot">:</div>
                    </div>
                    <div class="details-value">${
                      data.chestLength || "N/A"
                    }</div>
                  </div>
                  <div class="content-two-grid">
                    <div class="label-wrapper">
                      <div class="label">Waist/Midriff/Below Bust</div>
                      <div class="dot">:</div>
                    </div>
                    <div class="details-value">${
                      data.waistLength || "N/A"
                    }</div>
                  </div>
                  <div class="content-two-grid">
                    <div class="label-wrapper">
                      <div class="label">Shoulder</div>
                      <div class="dot">:</div>
                    </div>
                    <div class="details-value">${
                      data.shoulderLength || "N/A"
                    }</div>
                  </div>
                </div>
                <div class="">
                  <div class="content-two-grid">
                    <div class="label-wrapper">
                      <div class="label">Front Neck Depth</div>
                      <div class="dot">:</div>
                    </div>
                    <div class="details-value">${
                      data.frontNeckDepthLength || "N/A"
                    }</div>
                  </div>
                  <div class="content-two-grid">
                    <div class="label-wrapper">
                      <div class="label">Shoulder to Apex Point</div>
                      <div class="dot">:</div>
                    </div>
                    <div class="details-value">${
                      data.shoulderToApex || "N/A"
                    }</div>
                  </div>
                  <div class="content-two-grid">
                    <div class="label-wrapper">
                      <div class="label">Back Neck Depth</div>
                      <div class="dot">:</div>
                    </div>
                    <div class="details-value">${
                      data.backNeckDepth || "N/A"
                    }</div>
                  </div>
                </div>
              </div>
            </div>
          `;
      $("#measurementDetailsContent").html(modalContent);
    } else {
      $("#measurementDetailsContent").html(
        "<p>No measurement details available for this product.</p>"
      );
    }
  });

  //   const msnmsn = document.getele

  updateCartUI();
});
